import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomePlus"><Path d="M3.5 8.5V20.5H20.5V8.5L12 3.5L3.5 8.5Z" stroke="currentColor"/><Path d="M12 10V16" stroke="currentColor"/><Path d="M9 13H15" stroke="currentColor"/></CentralIconBase>;
});

export default IconHomePlus;
